export default function Header() {
  return (
    <div className="p-2">
      <h3 style={{ fontSize: "1.2rem", color: "#007bff", fontWeight: "bold" }}>
        Prescription History
      </h3>
    </div>
  );
}
